<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <employee-claims-report-table-list />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      EmployeeClaimsReportTableList: () => import('@/components/employee/claims/report/TableList'),
    },
    metaInfo () {
      return {
        title: 'Claim Report',
      }
    },
  }
</script>
